import styles from './index.module.less'
import ChatList from '@/pages/messageChat/ChatList'
import useChatStore, { getDialogKey } from '@/store/chatStore.ts'
import { useShallow } from 'zustand/react/shallow'
import { Col, Modal, Row, Spin } from 'antd'
import { useDebounceEffect, useSetState } from 'ahooks'
import chat from '@/model/Chat.ts'
import { getLastMessage, getMessage, getUnReadCount } from '@/services/pns.ts'
import ChatDialog from '@/pages/messageChat/ChatDialog'
import { useFileUrlPrefix } from 'shj-utils'
import { useCallback, useRef } from 'react'
import { throttle } from 'lodash-es'
import { triggerEvent } from '@/utils/customEvent.ts'
import AnnouncementModal from '@/pages/messageChat/MessageList/AnnouncementModal.tsx'
import dayjs from 'dayjs'
import { fetchMessage } from '@/pages/messageChat/service.ts'

function MessageList(props: any) {
  const { setChatLoading, setChatNoMore, active } = props
  const {
    chatState,
    messageState,
    setChatDataCount,
    setChatData,
    chatData,
    messageData,
    setMessageData,
    setMessageDataLastUpdatedTime,
    pullDialogData,
  } = useChatStore(
    useShallow((state: any) => ({
      chatState: state.chatState,
      setChatData: state.setChatData,
      chatData: state.chatData,
      setChatDataCount: state.setChatDataCount,
      messageData: state.messageData,
      messageState: state.messageState,
      setMessageData: state.setMessageData,
      setMessageDataLastUpdatedTime: state.setMessageDataLastUpdatedTime,
      pullDialogData: state.pullDialogData,
    }))
  )

  const [state, setState] = useSetState({
    loading: false,
  })

  const fetchList = async () => {
    if (!chatData['MESSAGE']?.length) {
      setState({ loading: true })
    }
    return getLastMessage()
      .then(res => {
        const data = chat.convertContacts(
          res?.filter?.(d => !['DATA_UPDATES'].includes(d?.message?.bodyType))
        )
        setChatData({
          MESSAGE: data,
        })
        return data
      })
      .finally(() => {
        setState({ loading: false })
      })
  }

  const _fetchMessage = async (contact, lastItem?) => {
    const msgKey = getDialogKey(chatState)
    setChatLoading(msgKey, true)
    return fetchMessage(contact, lastItem)
      .then((messageItems: any) => {
        // appendMessageData([messageItem, ...messageItems])
        if (messageItems.length < 10) {
          setChatNoMore(msgKey, true)
        }
        return messageItems
      })
      .finally(() => {
        setChatLoading(msgKey, false)
      })
  }

  const fetchUnCount = async fromId => {
    // fromId：联系人 id
    return getUnReadCount({ fromType: 'APP', fromId }).then(unReadCount => {
      setChatDataCount([
        {
          fromId,
          unReadCount,
        },
      ])
    })
  }

  const fetchMore = () => {
    pullDialogData(_fetchMessage).then(() => {
      const active = chatState.activeDict[chatState.chatTabKey]
      if (active) {
        fetchUnCount(active.id)
      }
      triggerEvent('UPDATE_MESSAGE_COUNT')
    })
  }

  useDebounceEffect(
    () => {
      // console.log('useDebounceEffect', chatState.chatTabKey)
      if (chatState.chatTabKey === 'MESSAGE') {
        fetchList().then(items => {
          if (!active) {
            handleSelect(items[0])
          }
        })
      }
    },
    [chatState.chatTabKey],
    { wait: 200 }
  )

  useDebounceEffect(
    () => {
      window.addEventListener('FETCH_MESSAGE_LIST', fetchMore)
      return () => {
        window.removeEventListener('FETCH_MESSAGE_LIST', fetchMore)
      }
    },
    [],
    { wait: 200 }
  )

  const handleSelect = d => {
    props.onSelect?.(d)
    const key = chatState.chatTabKey + d.id
    if (!messageData[key]) {
      _fetchMessage(d).then(messageItems => {
        // appendMessageData([messageItem, ...messageItems])
        const time = dayjs().format('YYYY-MM-DD HH:mm:ss')
        setMessageData(key, [...messageItems])
        setMessageDataLastUpdatedTime(key, time)

        setTimeout(() => {
          // chatRef.current?.scrollToBottom?.()
          triggerEvent('SCROLL_TO_BOTTOM')
          triggerEvent('UPDATE_MESSAGE_COUNT') // 更新全局 - 菜单数量展示
          fetchUnCount(d.id)
        }, 0)
      })
    } else {
      setTimeout(() => {
        // chatRef.current?.scrollTop?.(messageState.scroll[d.id])
        triggerEvent('SCROLL_TO', messageState.scroll[key])
      }, 0)
    }
  }

  return (
    <Spin spinning={state.loading}>
      <ChatList {...props} onSelect={handleSelect} data={chatData['MESSAGE']} />
    </Spin>
  )
}

// 消息列表 对话框容器组件
export const MessageDialog = props => {
  const { onScroll, onReload } = props

  const [state, setState] = useSetState({
    announcementOpen: false,
    announcementItem: null,
  })

  const { chatState, setMessageData, setMessageDataLastUpdatedTime } = useChatStore(
    useShallow((state: any) => ({
      chatState: state.chatState,
      setMessageData: state.setMessageData,
      setMessageDataLastUpdatedTime: state.setMessageDataLastUpdatedTime,
    }))
  )

  const handleReachTop = useCallback(
    throttle(() => {
      triggerEvent('FETCH_MESSAGE_LIST')
    }, 600),
    []
  )

  const handleReload = async chatActive => {
    const key = chatState.chatTabKey + chatActive.id
    // console.log(props.messageData)
    return fetchMessage(chatActive).then(messageItems => {
      const time = dayjs().format('YYYY-MM-DD HH:mm:ss')
      setMessageData(key, [...messageItems])
      setMessageDataLastUpdatedTime(key, time)
    })
  }

  const handleItemClick = (item, data) => {
    // console.log('handleItemClick', item, data.time)
    setState({
      announcementOpen: true,
      announcementItem: { ...item, time: data.time },
    })
  }

  return (
    <>
      <ChatDialog
        {...props}
        data={chatState.activeDict[chatState.chatTabKey]}
        onReachTop={handleReachTop}
        onScroll={onScroll}
        onReload={handleReload}
        hideInput
        onMessageItemClick={handleItemClick}
      />
      <AnnouncementModal
        open={state.announcementOpen}
        onClose={() => setState({ announcementOpen: false })}
        data={state.announcementItem}
      />
    </>
  )
}

MessageList.Dialog = MessageDialog
export default MessageList
